import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import styles from "./editPolicy.module.scss";
import RadioLabel from "./RadioLabel";

const IsBlocker = (): React.JSX.Element => {
  const { formState } = useFormContext();

  return (
    <Form.RadioGroup
      id="blocker"
      label="CI/CD status"
      isRequired
      name="blocker"
      items={[
        {
          id: "fail",
          value: "fail",
          label: (
            <RadioLabel
              label="Fail"
              tooltip="CI/CD fail configures this policy to stop the build process, and prevent code merge or software release before issue detected by this policy is resolved."
            />
          ),
        },
        {
          id: "pass",
          value: "pass",
          label: (
            <RadioLabel
              label="Pass"
              tooltip="CI/CD pass configures this policy to not influence the build process."
            />
          ),
        },
      ]}
      errors={formState.errors}
      orientation="horizontal"
      radioGroupClassName={styles["radio-group"]}
    />
  );
};

export default IsBlocker;
